import { ThunkAction } from 'redux-thunk';
import { AppState } from '../../types';
import { AnyAction } from 'redux';
import { getAuthToken } from '../../../utils/auth/getAuthToken';
import axios from 'axios';
import { SentinelUserInfo } from './sentinelUserInfo';
import APIS from '../../../utils/apiUrl';
import moment from 'moment/moment';
import { authActions } from '../actions';

export const updateTosAcceptanceDate = (): ThunkAction<void, AppState, undefined, AnyAction> => async dispatch => {
  try {
    // Since we need to update user info from the call's response, we'll treat this like a fetchUserInfo/fetchGuestInfo
    dispatch(authActions.fetchUserStart());
    const token = await getAuthToken();
    if (!token) throw new Error('Tried to fetch user info without an auth token!');
    const accessToken = token.access.token;
    const response = await axios.put<SentinelUserInfo>(
      `${APIS.PORTAL_API}/api/job-report-guests/updateTosAcceptedAt`,
      {
        sentinelLinkTOSAcceptedAt: moment().toISOString(true),
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    if (response.data.sentinelLinkTOSAcceptedAt) {
      dispatch(authActions.updateTosAcceptedAtSuccess({ tosAcceptedAt: response.data.sentinelLinkTOSAcceptedAt }));
    } else {
      dispatch(authActions.fetchUserFailure());
    }
  } catch (e) {
    dispatch(authActions.fetchUserFailure());
    console.error(e);
    throw e;
  }
};
